import React from 'react';
import { VoucherFormSection } from '../Section';
import VoucherFormComment from './Comments/VoucherFormComment';
import { Icon, IconChat } from '@flixbus/honeycomb-icons-react';
import styles from '../voucher-form.module.scss';

interface VoucherFormCommentsProps {
  template?: {
    usageType: string;
    disableAllowedPlatforms: boolean;
    disableValidity: boolean;
  };
}

const VoucherFormComments: React.FC<VoucherFormCommentsProps> = () => {
  return (
    <VoucherFormSection
      title={
        <>
          <Icon InlineIcon={IconChat} extraClasses={styles.commentIcon} /> Comments
        </>
      }
      subtitle='(optional)'
      inputs={
        <>
          <VoucherFormComment />
        </>
      }
    />
  );
};

export default VoucherFormComments;
